import React from 'react';
import { navigateTo } from "gatsby-link"
import './YellowButtonMD.css';

const YellowButtonMD = (props) => {
    return (
        <button 
            className = "YellowButtonMD"
            role = "button"
            onClick = {() => navigateTo(props.path)}>
        {props.children}
        </button>
    );
}

export default YellowButtonMD;


// WEBPACK FOOTER //
// ./src/components/Buttons/YellowButtonMD.js